import { isDefined } from "@clipboard-health/util-ts";
import { differenceInMinutes, hoursToMinutes, parseISO } from "date-fns";

import { type ComputedArrivalData } from "./computeArrivalData";
import { useArrivalTimeConfig } from "./useArrivalTimeConfig";
import { useIsArrivalTimeEligible } from "./useIsArrivalTimeEligible";

interface UseShouldShowArrivalTimeModalProps {
  shiftStartIso: string | undefined;
  computedArrivalData: ComputedArrivalData | undefined;
}

export function useShouldShowArrivalTimeModal(props: UseShouldShowArrivalTimeModalProps) {
  const { shiftStartIso, computedArrivalData } = props;

  const { shortLeadTimeOffsetInHours } = useArrivalTimeConfig();

  const isShortLeadTime = useIsArrivalTimeEligible({
    shiftStartIso: shiftStartIso ?? undefined,
  });

  if (!isDefined(shiftStartIso)) {
    return false;
  }

  const hasComputedArrivalData = isDefined(computedArrivalData);

  const diffMinutes = differenceInMinutes(parseISO(shiftStartIso), new Date());

  // If shift starts within shortLeadTimeOffsetInHours (usually 4 hours) and 24 hours, show arrival time modal
  const isShiftWithinWindowForArrivalTimeModal =
    diffMinutes > hoursToMinutes(shortLeadTimeOffsetInHours) && diffMinutes <= hoursToMinutes(24);

  return (hasComputedArrivalData && isShortLeadTime) || isShiftWithinWindowForArrivalTimeModal;
}
